import React from 'react';
import { percentage } from './labels';

var RADIUS = 54;
var CIRCUMFERENCE = 2 * Math.PI * RADIUS;

// Status composition donut. Drawn as SVG arcs so the segments scale with the data and
// take their colour from currentColor via the segment classes, not hardcoded fills.
export default function StatusDonut({ funnel, labels }) {
  var scheduled = (funnel && funnel.scheduled) || 0;
  var segments = [
    { key: 'complete', value: (funnel && funnel.complete) || 0, label: labels.complete },
    { key: 'in-progress', value: (funnel && funnel.in_process) || 0, label: labels.in_progress },
    { key: 'no-show', value: (funnel && funnel.no_show) || 0, label: labels.no_show }
  ];

  var offset = 0;

  return (
    <div className="card ehc-monitoring__card">
      <div className="card-header ehc-monitoring__card-header">
        <span className="ehc-monitoring__eyebrow">{labels.eyebrow}</span>
      </div>
      <div className="card-body ehc-monitoring__donut-body">
        <div className="ehc-monitoring__donut">
          <svg viewBox="0 0 140 140" role="img" aria-label={labels.eyebrow}>
            <circle className="ehc-monitoring__donut-track" cx="70" cy="70" r={RADIUS} />
            {segments.map(function (segment) {
              var length = scheduled ? (segment.value / scheduled) * CIRCUMFERENCE : 0;
              var dash = length + ' ' + (CIRCUMFERENCE - length);
              var rotation = 'rotate(' + (offset * 360 - 90) + ' 70 70)';
              offset += scheduled ? segment.value / scheduled : 0;

              return (
                <circle
                  key={segment.key}
                  className={'ehc-monitoring__donut-seg ehc-monitoring__donut-seg--' + segment.key}
                  cx="70"
                  cy="70"
                  r={RADIUS}
                  strokeDasharray={dash}
                  transform={rotation}
                />
              );
            })}
          </svg>
          <div className="ehc-monitoring__donut-center">
            <strong>{scheduled}</strong>
            <span>{labels.center_caption}</span>
          </div>
        </div>

        <ul className="ehc-monitoring__donut-legend">
          {segments.map(function (segment) {
            return (
              <li key={segment.key}>
                <i className={'ehc-monitoring__swatch ehc-monitoring__swatch--' + segment.key} />
                <span className="ehc-monitoring__donut-label">{segment.label}</span>
                <span className="ehc-monitoring__donut-value">{segment.value}</span>
                <span className="ehc-monitoring__donut-pct">
                  {percentage(segment.value, scheduled)}%
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
